/**
 * Strip the member count a bucket label carries — `Mar 2026 [6]` becomes `Mar 2026`.
 *
 * `GroupOperation` appends ` [n]` so list-shaped sinks (UpSet, shared/unique, overlap heatmap) can
 * show how big a bucket is, and there it is useful. On a chart axis it is not: the bar already shows
 * the size, the suffix doubles the label length so it wraps where a shorter one does not, and filled
 * date intervals have no count to show — leaving one axis carrying two label shapes.
 */
export const axisLabelOf = (bucketLabel: string): string => bucketLabel.replace(/\s*\[\d+\]$/, '')
